import REDIRECT from "~/graphql/redirect.graphql";
import { permanentRedirect, redirectHomeOnMissing } from "~/helpers/redirect";

async function lookUpRedirectRule(context, path) {
  try {
    const { redirect } = await context.$query(REDIRECT, { path });
    return redirect;
  } catch (error) {
    context.$logger?.error("Redirect rule lookup failed", error);
    return null;
  }
}

export async function redirectByRuleOrHomeOnMissing(context) {
  const location = await lookUpRedirectRule(context, context.route.path);
  if (!location) {
    redirectHomeOnMissing(context);
    return;
  }
  permanentRedirect({
    res: context.res,
    redirect: context.redirect,
    location,
    requestUrl: context.route.fullPath,
  });
}
